module.exports = __webpack_public_path__ + "img/GH-kyujin-programmer001.6bab25d5.webp";